import { DeliveryProviderMerchantConfigurationTypes } from "./delivery-provider-merchant.config";

export type DeliveryProviderConfigurationTypes = keyof typeof DeliveryProviderMerchantConfigurationTypes;